export default __webpack_public_path__ + "static/media/all-projects.819dd283.jpg";